import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';
const NotificationProvider = (props) => {
  const api = new API();
  const [notifyTableFilter, setNotifyTableFilter] = useState({
    page: 1,
    limit: 20,
  });
  const [notifyList, setNotifyList] = useState([]);
  const [notifyListLoader, setNotifyListLoader] = useState(false);
  const [notifyQbankList, setNotifyQbankList] = useState([]);
  const [notifyQbankListLoader, setNotifyQbankListLoader] = useState(false);
  const [notifyTestseriesList, setNotifyTestseriesList] = useState([]);
  const [notifyTestseriesListLoader, setNotifyTestseriesListLoader] = useState(false);
  const [notifyVideoList, setNotifyVideoList] = useState([]);
  const [notifyVideoListLoader, setNotifyVideoListLoader] = useState(false);
  const [notifyPearlsList, setNotifyPearlsList] = useState([]);
  const [notifyPearlsListLoader, setNotifyPearlsListLoader] = useState(false);
  const [notifyDNBMDList, setNotifyDNBMDList] = useState([]);
  const [notifyDNBMDListLoader, setNotifyDNBMDListLoader] = useState(false);
  const [notifyUpdateList, setNotifyUpdateList] = useState([]);
  const [notifyUpdateListLoader, setNotifyUpdateListLoader] = useState(false);
  const [notifyCategoryList, setNotifyCategoryList] = useState([]);
  const [notifyCategoryListLoader, setNotifyCategoryListLoader] = useState(false);
  const [notifySubCategoryList, setNotifySubCategoryList] = useState([]);
  const [notifySubCategoryListLoader, setNotifySubCategoryListLoader] = useState(false);
  const [createNotifyFromData, setCreateNotifyFromData] = useState({
    campaign_name: "",
    notification_type: "",
    qbanks_id: "",
    videos_id: "",
    pearls_id: "",
    updates_id: "",
    dnbmd_id: "",
    testseries_id: "",
    users_id: "",
    title: "",
    message: "",
    category_id: "",
    subcategory_id: "",
    send_to: "",
  });
  const [notifyStudentList, setNotifyStudentList] = useState([]);
  const [notifyStudentListLoader, setNotifyStudentListLoader] = useState(false);
  const [notifyCreateForm] = Form.useForm();
  const [notifyCreateLoader, setNotifyCreateLoader] = useState(false);
  const [inAppMessageCreateForm] = Form.useForm();
  const [inAppMessageCreateLoader, setInAppMessageCreateLoader] = useState(false);
  const [multiInAppMessageCreateForm] = Form.useForm();
  const [multiInAppMessageCreateLoader, setMultiInAppMessageCreateLoader] = useState(false);

  const [inAppMessageTableFilter, setInAppMessageTableFilter] = useState({
    page: 1,
    limit: 20,
  });
  const [inAppMessageList, setInAppMessageList] = useState([]);
  const [inAppMessageListLoader, setInAppMessageListLoader] = useState(false);

  const [createMultiNotifyFromData, setCreateMultiNotifyFromData] = useState({
    campaign_name: "",
    notification_type: "content",
    title: "",
    message: "",
    message_body: "",
    all_category: [],
    all_subcategory: [],
    send_to: "",
    users_id: [],
  });
  const [notifyMultiStudentList, setNotifyMultiStudentList] = useState([]);
  const [notifyMultiStudentListLoader, setNotifyMultiStudentListLoader] = useState(false);
  const [notifyMultiCreateForm] = Form.useForm();
  const [notifyMultiCreateLoader, setNotifyMultiCreateLoader] = useState(false);

  const createInAppMessage = async (data,navigate) => {
    setInAppMessageCreateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pushnotification/create_inappmessage", data, (err, res) => {
        if (res?.data?.status === 200) { 
          inAppMessageCreateForm.resetFields();
          navigate("/inappmessage_list");
          Widget.showMessage("success", res?.data?.message);
        } else { 
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setInAppMessageCreateLoader(false);
      }));
  }

  const createMultiInAppMessage = async (data,navigate) => {
    setMultiInAppMessageCreateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pushnotification/create_inappmessage_multi", data, (err, res) => {
        if (res?.data?.status === 200) { 
          multiInAppMessageCreateForm.resetFields();
          navigate("/inappmessage_list");
          Widget.showMessage("success", res?.data?.message);
        } else { 
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setMultiInAppMessageCreateLoader(false);
      }));
  }

  const createNotification = async (data,navigate) => {
    const send_to = data?.send_to;
    if(send_to==="all") {
      data.users_id = notifyStudentList?.map(item => item?.value);
    }
    // console.log("data",data);
    // return;
    const formData = new FormData();
    formData.append("campaign_name", data?.campaign_name || "");
    formData.append("notification_type", data?.notification_type || "");
    formData.append("qbanks_id", data?.qbanks_id || "");
    formData.append("videos_id", data?.videos_id || "");
    formData.append("pearls_id", data?.pearls_id || "");
    formData.append("updates_id", data?.updates_id || "");
    formData.append("dnbmd_id", data?.dnbmd_id || "");
    formData.append("testseries_id", data?.testseries_id || "");
    formData.append("title", data?.title || "");
    formData.append("message", data?.message || "");
    formData.append("message_body", data?.message_body || "");
    formData.append("category_id", data?.category_id || "");
    formData.append("subcategory_id", data?.subcategory_id || "");
    formData.append("send_to", data?.send_to || "");
    if(data?.users_id?.length > 0) {
      data.users_id.forEach(function(user) {
        formData.append("users_id[]", user);
      });
    }
    // return;
    setNotifyCreateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pushnotification/create_notofication", formData, (err, res) => {
        if (res?.data?.status === 200) { 
          notifyCreateForm.resetFields();
          navigate("/notification_list");
          Widget.showMessage("success", res?.data?.message);
        } else { 
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setNotifyCreateLoader(false);
      }));
  }

  const createMultiNotification = async (data,navigate) => {
    const send_to = data?.send_to;
    if(send_to==="all") {
      data.users_id = notifyMultiStudentList?.map(item => item?.value);
    }
    const formData = new FormData();
    formData.append("campaign_name", data?.campaign_name || "");
    formData.append("notification_type", "content");
    formData.append("title", data?.title || "");
    formData.append("message", data?.message || "");
    formData.append("message_body", data?.message_body || "");
    formData.append("send_to", data?.send_to || "");
    
    if(data?.all_category?.length > 0) {
      data.all_category.forEach(function(cat) {
        formData.append("all_category", cat);
      });
    }
    if(data?.all_subcategory?.length > 0) {
      data.all_subcategory.forEach(function(subcat) {
        formData.append("all_subcategory", subcat);
      });
    }
    if(data?.users_id?.length > 0) {
      data.users_id.forEach(function(user) {
        formData.append("users_id", user);
      });
    }
    setNotifyMultiCreateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pushnotification/create_multi_notification", formData, (err, res) => {
        if (res?.data?.status === 200) { 
          notifyMultiCreateForm.resetFields();
          navigate("/notification_list");
          Widget.showMessage("success", res?.data?.message);
        } else { 
          Widget.showMessage("error", err?.response?.data?.message || "Something went wrong");
        }
        setNotifyMultiCreateLoader(false);
      }));
  }

  const fetchNotifyList = async () => {
    setNotifyListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/push_natofication_list", { ...notifyTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyList(res?.data?.data);
        } else {
          setNotifyList([]);
        }
        setNotifyListLoader(false);
      }));
  }

  const fetchInAppMessageList = async () => {
    setInAppMessageListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/inappmessage_list", { ...inAppMessageTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setInAppMessageList(res?.data?.data);
        } else {
          setInAppMessageList([]);
        }
        setInAppMessageListLoader(false);
      }));
  }

  const fetch_qbank_list = async () => {
    setNotifyQbankListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_qbank_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyQbankList(res?.data?.data);
        } else {
          setNotifyQbankList([]);
        }
        setNotifyQbankListLoader(false);
      }));
  }

  const fetch_testseries_list = async () => {
    setNotifyTestseriesListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_testseries_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyTestseriesList(res?.data?.data);
        } else {
          setNotifyTestseriesList([]);
        }
        setNotifyTestseriesListLoader(false);
      }));
  }

  const fetch_video_list = async () => {
    setNotifyVideoListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_video_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyVideoList(res?.data?.data);
        } else {
          setNotifyVideoList([]);
        }
        setNotifyVideoListLoader(false);
      }));
  }
  const fetch_pearls_list = async () => {
    setNotifyPearlsListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_pearls_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyPearlsList(res?.data?.data);
        } else {
          setNotifyPearlsList([]);
        }
        setNotifyPearlsListLoader(false);
      }));
  }
  const fetch_dnbmd_list = async () => {
    setNotifyDNBMDListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_dnbmd_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyDNBMDList(res?.data?.data);
        } else {
          setNotifyDNBMDList([]);
        }
        setNotifyDNBMDListLoader(false);
      }));
  }
  const fetch_updates_list = async () => {
    setNotifyUpdateListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_updates_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyUpdateList(res?.data?.data);
        } else {
          setNotifyUpdateList([]);
        }
        setNotifyUpdateListLoader(false);
      }));
  }
  const fetch_category_list = async () => {
    setNotifyCategoryListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_category_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyCategoryList(res?.data?.data);
        } else {
          setNotifyCategoryList([]);
        }
        setNotifyCategoryListLoader(false);
      }));
  }
  const fetch_subcategory_list = async (id) => {
    if(!id) return;
    setNotifySubCategoryListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_subcategory_list", {
        category_id: id
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifySubCategoryList(res?.data?.data);
        } else {
          setNotifySubCategoryList([]);
        }
        setNotifySubCategoryListLoader(false);
      }));
  }
  const fetch_subcategory_list_multi = async (categories) => {
    if(!categories || categories.length === 0) {
      setNotifySubCategoryList([]);
      return;
    }
    setNotifySubCategoryListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pushnotification/get_subcategory_list_multi", {
        all_category: categories
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifySubCategoryList(res?.data?.data);
        } else {
          setNotifySubCategoryList([]);
        }
        setNotifySubCategoryListLoader(false);
      }));
  }

  const fetch_student_list_multi = async () => {
    if(!createMultiNotifyFromData.all_subcategory || createMultiNotifyFromData.all_subcategory.length === 0) {
      Widget.showMessage("error", "Please select subcategory");
      return;
    }
    setNotifyMultiStudentListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pushnotification/get_student_list_multi", {
        all_subcategory: createMultiNotifyFromData.all_subcategory
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyMultiStudentList(res?.data?.data);
        } else {
          setNotifyMultiStudentList([]);
        }
        setNotifyMultiStudentListLoader(false);
      }));
  }

  const fetch_student_list = async () => {
    //createNotifyFromData
    const data = {};
    if(createNotifyFromData?.notification_type==="") {
      Widget.showMessage("error", "Please select notification type");
      return;
    }
    if(createNotifyFromData?.notification_type==="content") {
      if(!createNotifyFromData.category_id || !createNotifyFromData.subcategory_id) {
        Widget.showMessage("error", "Please select category and subcategory");
        return;
      }
      data.notification_type = createNotifyFromData?.notification_type;
      data.category_id = createNotifyFromData?.category_id;
      data.subcategory_id = createNotifyFromData?.subcategory_id;
    }
    if(createNotifyFromData?.notification_type!=="content") {
      if(createNotifyFromData?.notification_type==="qbank") {
        if(!createNotifyFromData.qbanks_id) {
          Widget.showMessage("error", "Please select qbank");
          return;
        }
        data.notification_type = createNotifyFromData?.notification_type;
        data.id = createNotifyFromData?.qbanks_id;
      }
      if(createNotifyFromData?.notification_type==="videos") {
        if(!createNotifyFromData.videos_id) {
          Widget.showMessage("error", "Please select video");
          return;
        }
        data.notification_type = createNotifyFromData?.notification_type;
        data.id = createNotifyFromData?.videos_id;
      }
      if(createNotifyFromData?.notification_type==="pearls") {
        if(!createNotifyFromData.pearls_id) {
          Widget.showMessage("error", "Please select pearl");
          return;
        }
        data.notification_type = createNotifyFromData?.notification_type;
        data.id = createNotifyFromData?.pearls_id;
      }
      if(createNotifyFromData?.notification_type==="updates") {
        if(!createNotifyFromData.updates_id) {
          Widget.showMessage("error", "Please select update");
          return;
        }
        data.notification_type = createNotifyFromData?.notification_type;
        data.id = createNotifyFromData?.updates_id;
      }
      if(createNotifyFromData?.notification_type==="dnbmd") {
        if(!createNotifyFromData.dnbmd_id) {
          Widget.showMessage("error", "Please select DNBMD");
          return;
        }
        data.notification_type = createNotifyFromData?.notification_type;
        data.id = createNotifyFromData?.dnbmd_id;
      }
    
    if(createNotifyFromData?.notification_type==="testseries") {
      if(!createNotifyFromData.testseries_id) {
        Widget.showMessage("error", "Please select Test Series");
        return;
      }
      data.notification_type = createNotifyFromData?.notification_type;
      data.id = createNotifyFromData?.testseries_id;
    }
    }
    


    setNotifyStudentListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_student_list", {...data}, (err, res) => {
        if (res?.data?.status === 200) {
          setNotifyStudentList(res?.data?.data);
        } else {
          setNotifyStudentList([]);
        }
        setNotifyStudentListLoader(false);
      }));
  }

  return (
    <Context.Provider value={{
      ...props,
      fetchNotifyList,
      notifyTableFilter, setNotifyTableFilter,
      notifyList, setNotifyList,
      notifyListLoader, setNotifyListLoader,
      notifyCreateForm,
      notifyQbankList, setNotifyQbankList,
      notifyQbankListLoader, setNotifyQbankListLoader,
      notifyVideoList, setNotifyVideoList,
      notifyVideoListLoader, setNotifyVideoListLoader,
      notifyPearlsList, setNotifyPearlsList,
      notifyPearlsListLoader, setNotifyPearlsListLoader,
      notifyUpdateList, setNotifyUpdateList,
      notifyUpdateListLoader, setNotifyUpdateListLoader,
      notifyCategoryList, setNotifyCategoryList,
      notifyCategoryListLoader, setNotifyCategoryListLoader,
      notifySubCategoryList, setNotifySubCategoryList,
      notifySubCategoryListLoader, setNotifySubCategoryListLoader,
      createNotifyFromData, setCreateNotifyFromData,
      notifyStudentList, setNotifyStudentList,
      notifyStudentListLoader, setNotifyStudentListLoader,
      fetch_qbank_list,
      fetch_video_list,
      fetch_pearls_list,
      fetch_updates_list,
      fetch_category_list,
      fetch_subcategory_list,
      fetch_student_list,
      createNotification,
      notifyCreateLoader, 
      setNotifyCreateLoader,
      fetch_dnbmd_list,
      notifyDNBMDList, setNotifyDNBMDList,
      notifyDNBMDListLoader, setNotifyDNBMDListLoader,
      notifyTestseriesList, setNotifyTestseriesList,
      notifyTestseriesListLoader, setNotifyTestseriesListLoader,
      fetch_testseries_list,
      inAppMessageCreateForm,
      inAppMessageCreateLoader, setInAppMessageCreateLoader,
      createInAppMessage,
      multiInAppMessageCreateForm,
      multiInAppMessageCreateLoader, setMultiInAppMessageCreateLoader,
      createMultiInAppMessage,
      fetchInAppMessageList,
      inAppMessageTableFilter, setInAppMessageTableFilter,
      inAppMessageList, setInAppMessageList,
      inAppMessageListLoader, setInAppMessageListLoader,
      createMultiNotifyFromData, setCreateMultiNotifyFromData,
      notifyMultiStudentList, setNotifyMultiStudentList,
      notifyMultiStudentListLoader, setNotifyMultiStudentListLoader,
      notifyMultiCreateForm, 
      notifyMultiCreateLoader, setNotifyMultiCreateLoader,
      createMultiNotification,
      fetch_student_list_multi,
      fetch_subcategory_list_multi,
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default NotificationProvider;

